import { useEffect } from 'react';
import { CookieManager } from '@goalsetter/classroom-auth-sdk';

export default function CookieConfigProvider() {
  useEffect(() => {
    if (import.meta.env.MODE === 'production') {
      CookieManager.configure({ domain: '.goalsettereducation.com' });
    }
  }, []);
  return null;
}
